import { Route, Routes } from "react-router-dom";
import "./App.css";
import "react-datepicker/dist/react-datepicker.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import DaCalculation from "./pages/All_services/DaCalculation"; // Fix import here
import GovtBooksGr from "./pages/All_services/GovtBooksGr"; // Fix import here
import IncometaxCalcuation from "./pages/All_services/IncometaxCalcuation"; // Fix import here

// user dashboard
import Usidebar from "./components/Usidebar";
import { useEffect, useState } from "react";
import Dashboard from "./pages/UserDashboard/Dashboard";
import Uheader from "./components/Uheader";
import AllServices from "./pages/UserDashboard/AllServices";
import Uprofile from "./pages/UserDashboard/Uprofile";

// admin dashboard
import ADashboard from "./pages/AdminDashboard/Dashboard";
import Asidebar from "./components/Asidebar";
import Aheader from "./components/Aheader";
import MyApplications from "./pages/UserDashboard/Myaplications";
import ApplicationConsole from "./pages/AdminDashboard/ApplicationConsole";

// login
import Sign_in from "./pages/Login/Sign_in";
import Sign_up from "./pages/Login/Sign_up";
import Forgot_password from "./pages/Login/Forgot_password";
import Addpdf from "./pages/AdminDashboard/Addpdf";
import ContactData from "./pages/AdminDashboard/ContactData";
import Uincometax from "./pages/UserDashboard/Uincometax";
import IncometaxTable from "./pages/UserDashboard/IncometaxTable";
import GpfNonRefundable from "./pages/UserDashboard/GpfNonRefundabe";
import ITCompleteWork from "./pages/UserDashboard/ITCompleteWork";
import EditIncomeTaxTable from "./pages/UserDashboard/EditIncomeTaxTable";
import ITPrintData from "./pages/UserDashboard/ITPrintData";
import AdminLogin from "./pages/AdminDashboard/AdminLogin";
import UsersData from "./pages/AdminDashboard/UsersData";
import GPFNRWork from "./pages/UserDashboard/GPFNRWork";
import GpfnrWorkPrint from "./pages/UserDashboard/GpfnrWorkPrint";
import InterDistrictTransfer from "./pages/UserDashboard/InterDistrictTransfer";
import EditGPFNonRefundable from "./pages/UserDashboard/EditGPFNonRefundable";
import EditInterDistrictTransfer from "./pages/UserDashboard/EditInterDistrictTransfer";
import InterDistrictTransferWork from "./pages/UserDashboard/InterDistrictTransferWork";
import InterDistrictTransferPrint from "./pages/UserDashboard/InterDistrictTransferPrint";
import PensionProposal from "./pages/UserDashboard/PensionProposal";
import PensionProposalPrint from "./pages/UserDashboard/PensionProposalPrint";
import GpfFinalPrint from "./pages/UserDashboard/GpfFinalPrint";
import PrintGISFinal from "./pages/UserDashboard/PrintGISFinal";
import PrintLeaveEncashment from "./pages/UserDashboard/PrintLeaveEncashment";
import ITExcel from "./pages/UserDashboard/ITExcel";

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [adminSidebarOpen, setAdminSidebarOpen] = useState(false);
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/da_calculation" element={<DaCalculation />} />{" "}
        {/* Fix route here */}
        <Route path="/govt_books_gr" element={<GovtBooksGr />} />
        <Route path="/incometax_calcuation" element={<IncometaxCalcuation />} />
        {/* login */}
        <Route path="/sign_in" element={<Sign_in />} />
        <Route path="/sign_up" element={<Sign_up />} />
        <Route path="/forgot_password" element={<Forgot_password />} />
        {/* user dashboard */}
        {/* <Route path="/dashboard" element={<Uheader />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="allServices" element={<AllServices />} />
          <Route path="uprofile" element={<Uprofile />} />
          <Route path="my_application" element={<MyApplications />} />
          <Route path="user_incometax" Component={Uincometax} />
          <Route path="user_incometax_complete" element={<ITCompleteWork />} />
          <Route path="income_tax_table" element={<IncometaxTable />} />
          <Route path="gpf_non_refundable" element={<GpfNonRefundable />} />
          <Route path="gpf_non_refundable_work" element={<GPFNRWork />} />

          <Route path="print_income_tax_table/:id" element={<ITPrintData />} />
          <Route
            path="print_gpfnrwork_table/:id"
            element={<GpfnrWorkPrint />}
          />
        </Route> */}
        <Route
          path="/dashboard/edit_income_tax_table/:id"
          element={<EditIncomeTaxTable />}
        />
        <Route
          path="/dashboard/incometax_calcuation/:id"
          element={<IncometaxCalcuation />}
        />
        <Route
          path="/dashboard/print_gpfnrwork_table/:id"
          element={<GpfnrWorkPrint />}
        />
        <Route
          path="/dashboard/print_inter_district_transfer_table/:id"
          element={<InterDistrictTransferPrint />}
        />
        <Route
          path="/dashboard/print_pension_proposal_table/:id"
          element={<PensionProposalPrint />}
        />
        <Route
          path="/dashboard/print_gpf_final_table/:id"
          element={<GpfFinalPrint />}
        />
        <Route
          path="/dashboard/print_gis_final_table/:id"
          element={<PrintGISFinal />}
        />
        <Route
          path="/dashboard/print_leave_encashment/:id"
          element={<PrintLeaveEncashment />}
        />
        <Route
          path="/dashboard/*"
          element={
            <Dashboardroutes
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
            />
          }
        />
        {/* Admin Dashboard */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route
          path="/admin/*"
          element={
            <AdminDashboardroutes
              adminSidebarOpen={adminSidebarOpen}
              setAdminSidebarOpen={setAdminSidebarOpen}
            />
          }
        />
      </Routes>
    </div>
  );
}

function Dashboardroutes({ sidebarOpen, setSidebarOpen }) {
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("userName");

  return (
    <div className="flex h-screen overflow-hidden">
      <Usidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="flex-1 flex flex-col overflow-auto">
        <Uheader
          setSidebarOpen={setSidebarOpen}
          isLoggedIn={userId != null || userId != "null"}
          userName={userName}
        />
        <main className="flex-1 overflow-auto">
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="allServices" element={<AllServices />} />
            <Route path="uprofile" element={<Uprofile />} />
            <Route path="my_application" element={<MyApplications />} />
            <Route path="user_incometax" Component={Uincometax} />
            <Route
              path="user_incometax_complete"
              element={<ITCompleteWork />}
            />
            <Route path="income_tax_table" element={<IncometaxTable />} />
            <Route path="gpf_non_refundable" element={<GpfNonRefundable />} />
            <Route path="gpf_non_refundable_work" element={<GPFNRWork />} />
            <Route path="pension_proposal" element={<PensionProposal />} />
            <Route
              path="edit_gpfnrwork_table/:id"
              element={<EditGPFNonRefundable />}
            />
            <Route
              path="inter_district_transfer"
              element={<InterDistrictTransfer />}
            />
            <Route
              path="inter_district_transfer_work"
              element={<InterDistrictTransferWork />}
            />
            <Route
              path="edit_inter_district_transfer/:id"
              element={<EditInterDistrictTransfer />}
            />

            <Route
              path="print_income_tax_table/:id"
              element={<ITPrintData />}
            />

            <Route path="excel_income_tax_table/:id" element={<ITExcel />} />

            {/* </Route> */}
          </Routes>
        </main>
      </div>
    </div>
  );
}

function AdminDashboardroutes({ adminSidebarOpen, setAdminSidebarOpen }) {
  return (
    <div className="flex h-screen">
      <Asidebar
        adminSidebarOpen={adminSidebarOpen}
        setAdminSidebarOpen={setAdminSidebarOpen}
      />
      <div className="flex-1 flex flex-col overflow-auto">
        <Aheader setAdminSidebarOpen={setAdminSidebarOpen} />
        <main className="flex-1 overflow-y-auto">
          <Routes>
            <Route path="admin_dashboard" element={<ADashboard />} />
            <Route path="users_data" element={<UsersData />} />
            <Route path="applicationconsole" element={<ApplicationConsole />} />
            <Route path="add_pdf" element={<Addpdf />} />
            <Route path="contact_data" element={<ContactData />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default App;
